import React from 'react';
import { useParams, Navigate, useNavigate } from 'react-router-dom';
import FichaTecnica from '../components/FichaTecnica';
import { getProductById } from '../data/products';

// URL directa: /productos/ficha/:modeloId
function FichaTecnicaPage() {
  const { modeloId } = useParams();
  const navigate = useNavigate();
  const producto = getProductById(modeloId);

  if (!producto) return <Navigate to="/productos" replace />;

  return <FichaTecnica producto={producto} onClose={() => navigate('/productos')} />;
}

export default FichaTecnicaPage;
